/**
 * Auth State Management Types
 * Common types for authentication state across different state management solutions
 */
/**
 * Initial auth state
 */
export const initialAuthState = {
    user: null,
    isAuthenticated: false,
    isInitializing: true,
    isLoading: false,
    error: null,
    lastRefreshAt: null,
};
/**
 * Auth reducer
 */
export function authReducer(state, action) {
    switch (action.type) {
        case 'AUTH_INIT_START':
            return { ...state, isInitializing: true };
        case 'AUTH_INIT_COMPLETE':
            return {
                ...state,
                isInitializing: false,
                user: action.payload,
                isAuthenticated: action.payload !== null,
            };
        case 'LOGIN_START':
            return { ...state, isLoading: true, error: null };
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                isAuthenticated: true,
                error: null,
                lastRefreshAt: Date.now(),
            };
        case 'LOGIN_FAILURE':
            return {
                ...state,
                isLoading: false,
                user: null,
                isAuthenticated: false,
                error: action.payload,
            };
        case 'LOGOUT':
            return {
                ...initialAuthState,
                isInitializing: false,
            };
        case 'REFRESH_START':
            return { ...state, isLoading: true };
        case 'REFRESH_SUCCESS':
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                isAuthenticated: true,
                error: null,
                lastRefreshAt: Date.now(),
            };
        case 'REFRESH_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                // Keep user logged in if refresh fails - let caller decide to logout
            };
        case 'REFRESH_EXHAUSTED':
            return {
                ...initialAuthState,
                isInitializing: false,
                error: 'Session expired. Please log in again.',
            };
        case 'UPDATE_USER':
            return state.user
                ? { ...state, user: { ...state.user, ...action.payload } }
                : state;
        case 'CLEAR_ERROR':
            return { ...state, error: null };
        default:
            return state;
    }
}
//# sourceMappingURL=types.js.map